import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoute } from 'src/app/shared/constants/app-route.constant';
import { GlobalConfigKey, InterfaceText, PaymentType, StorageKey } from 'src/app/shared/constants/global-config.constant';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private router: Router
  ) { }

  isLoading = false;

  checkSessionExisted(): boolean {
    console.log(localStorage.getItem(StorageKey.SESSION_ID));
    if (localStorage.getItem(StorageKey.SESSION_ID) === null || localStorage.getItem(StorageKey.SESSION_ID) === undefined) {
      return false;
    }
    else {
      return true;
    }
  }

  showWarningPopup(title: string, text: string) {
    let timerInterval
    Swal.fire({
      icon: 'warning',
      title: title,
      text: text,
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        timerInterval = setInterval(() => {
        }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log('I was closed by the timer')
      }
    })
  }

  showSuccessPopup(title: string, text: string) {
    let timerInterval
    Swal.fire({
      icon: 'success',
      title: title,
      text: text,
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        timerInterval = setInterval(() => {
        }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log('I was closed by the timer')
      }
    })
  }

  showErrorPopup(title: string, text: string) {
    let timerInterval
    Swal.fire({
      icon: 'error',
      title: title,
      text: text,
    });
  }

  showPaymentNotPaidPopup() {
    let timerInterval
    Swal.fire({
      title: InterfaceText.PAYMENT_SCAN_NOT_PAID_TITLE,
      html: InterfaceText.PAYMENT_SCAN_NOT_PAID_TEXT,
      timer: 3000,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    })
  }

  /** The charge expired, failed or was reversed. Resolves once the popup has closed. */
  showPaymentFailedPopup(): Promise<void> {
    return Swal.fire({
      icon: 'error',
      title: InterfaceText.PAYMENT_SCAN_FAILED_TITLE,
      html: InterfaceText.PAYMENT_SCAN_FAILED_TEXT,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
    }).then(() => undefined);
  }

  /** The CONFIRM check itself failed (network/API error), not the payment. */
  showPaymentCheckErrorPopup() {
    Swal.fire({
      icon: 'warning',
      title: InterfaceText.PAYMENT_SCAN_CHECK_ERROR_TITLE,
      html: InterfaceText.PAYMENT_SCAN_CHECK_ERROR_TEXT,
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
    });
  }

  showUnknowErrorPopupAndConfirm(): Promise<boolean> {
    return Swal.fire({
      icon: 'warning',
      title: InterfaceText.PAYMENT_SCAN_PAYMENT_UNKNOWN_TITLE,
      html: InterfaceText.PAYMENT_SCAN_PAYMENT_UNKNOWN,
    }).then((result) => {
      if (result.isConfirmed) {
        return true
      } else if (result.isDenied) {
        return false
      }
      return false; // add this line to return false by default
    })
  }

  showRetryToast(currentAttempt: number, maxRetries: number) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'warning',
      title: `Retrying ${currentAttempt}/${maxRetries}`,
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      customClass: {
        popup: 'swal-toast-small'
      }
    });
  }



  clearPromotion(include_use: boolean = false) {
    localStorage.removeItem(StorageKey.PROMO_TYPE);
    localStorage.removeItem(StorageKey.PROMO_CODE);
    localStorage.removeItem(StorageKey.PROMO_AMOUNT);

    if (include_use) {
      localStorage.removeItem(StorageKey.PROMO_USE);
    }
  }

  clearPinUse() {
    localStorage.removeItem(StorageKey.IS_PIN_USE);
  }

  setPaymentTrxId(trxId: string) {
    localStorage.setItem(StorageKey.PAYMENT_TRX_ID, trxId);
  }

  getPaymentTrxId(): string {
    return localStorage.getItem(StorageKey.PAYMENT_TRX_ID);
  }

  clearTrxId() {
    localStorage.removeItem(StorageKey.PAYMENT_TRX_ID);
  }

  getBranchId(): string {
    return localStorage.getItem(StorageKey.BRANCH_ID);
  }

  roundNumberToTwoDecimalPlaces(number: number): number {
    return Math.round((number + Number.EPSILON) * 100) / 100;
  }

  goToPayment(code: string) {
    if (code === PaymentType.PROMPTPAY) {
      this.router.navigate([AppRoute.PAYMENT_PROMPTPAY]);
    }
    else if (code === PaymentType.TRUEMONEY) {
      this.router.navigate([AppRoute.PAYMENT_TRUEMONEY]);
    }
    else if (code === PaymentType.LINK) {
      this.router.navigate([AppRoute.PAYMENT_LINK]);
    }
    else if (code === PaymentType.CREDITCARD) {
      this.router.navigate([AppRoute.PAYMENT_CREDITCARD]);
    }
    else {
      this.router.navigate([AppRoute.PAYMENT_NOT_SUPPORTED]);
    }
  }

  getCurrentDate(): string {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  checkIfConfigNeedReload() {

      // GlobalConfigKey.USE_OMEGA_RANDOM,
      // GlobalConfigKey.FREE_WHITELIST_BRANCH,
      // GlobalConfigKey.USE_FACE_DETECTION,
      // GlobalConfigKey.SCULPTURE_BRANCH_HIDE_PAY,
      // GlobalConfigKey.SCULPTURE_BRANCH_SKIP_TERMS,
      // GlobalConfigKey.SCULPTURE_HIDE_PROMO_BUTTON


    // check if sessionStorage.getItem(StorageKey.USE_OMEGA_RANDOM) exist with value, if not exist return false, else return true
    const getConfigUseOmegaRandom = sessionStorage.getItem(GlobalConfigKey.USE_OMEGA_RANDOM);
    const getConfigFreeWhitelistBranch = sessionStorage.getItem(GlobalConfigKey.FREE_WHITELIST_BRANCH);
    const getConfigUseFaceDetection = sessionStorage.getItem(GlobalConfigKey.USE_FACE_DETECTION);
    const getConfigSculptureBranchHidePay = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_BRANCH_HIDE_PAY);
    const getConfigSculptureBranchSkipTerms = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_BRANCH_SKIP_TERMS);
    const getConfigUsePointCollection = sessionStorage.getItem(GlobalConfigKey.USE_POINT_COLLECTION);
    const getConfigSkipPointCollection = sessionStorage.getItem(GlobalConfigKey.SKIP_POINT_COLLECTION);
    const getConfigSculptureHidePromoButton = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_HIDE_PROMO_BUTTON);
    const getConfigBranchThemeMap = sessionStorage.getItem(GlobalConfigKey.BRANCH_THEME_MAP);
    const getConfigSkipPaymentSuccessPage = sessionStorage.getItem(GlobalConfigKey.SKIP_PAYMENT_SUCCESS_PAGE);

    if (getConfigUseOmegaRandom === null ||
      getConfigFreeWhitelistBranch === null ||
      getConfigUseFaceDetection === null ||
      getConfigSculptureBranchHidePay === null ||
      getConfigSculptureBranchSkipTerms === null ||
      getConfigUsePointCollection === null ||
      getConfigSkipPointCollection === null ||
      getConfigSculptureHidePromoButton === null ||
      getConfigBranchThemeMap === null ||
      getConfigSkipPaymentSuccessPage === null) {
      return true;
    }
    else {
      return false;
    }

  }

  getConfigUseOmegaRandom(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.USE_OMEGA_RANDOM);
    return JSON.parse(config);
  }

  getConfigFreeWhitelistBranch(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.FREE_WHITELIST_BRANCH);
    return JSON.parse(config);  
  }

  getConfigUseFaceDetection(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.USE_FACE_DETECTION);
    return JSON.parse(config);
  }

  getConfigSculptureBranchHidePay(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_BRANCH_HIDE_PAY);
    return JSON.parse(config);
  }

  getConfigSculptureBranchSkipTerms(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_BRANCH_SKIP_TERMS);
    return JSON.parse(config);
  }

  getConfigUsePointCollection(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.USE_POINT_COLLECTION);
    return JSON.parse(config);
  }

  getConfigSkipPointCollection(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.SKIP_POINT_COLLECTION);
    return JSON.parse(config);
  }

  getConfigSculptureHidePromoButton(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.SCULPTURE_HIDE_PROMO_BUTTON);
    return JSON.parse(config);
  }

  getConfigBranchThemeMap(): { [themeName: string]: string[] } {
    const config = sessionStorage.getItem(GlobalConfigKey.BRANCH_THEME_MAP);
    return JSON.parse(config);
  }

  getConfigSkipPaymentSuccessPage(): string[] {
    const config = sessionStorage.getItem(GlobalConfigKey.SKIP_PAYMENT_SUCCESS_PAGE);
    return JSON.parse(config);
  }

  /**
   * True when this device's branch should bypass the /payment-success tap and start the
   * dslrbooth session automatically.
   *
   * Exact match, not substring. The older skip_point_collection check uses
   * item.includes(branchCode), which makes 'SC-SWAROV-' match 'SC-SWAROV-1' — do not
   * inherit that bug here. Every failure path returns false, so a bad config edit can
   * only ever fall back to the normal tap-to-start page.
   */
  isSkipPaymentSuccessPageBranch(): boolean {
    try {
      const skipList = this.getConfigSkipPaymentSuccessPage();
      const branchCode = localStorage.getItem(StorageKey.BRANCH_CODE);

      if (!skipList || !branchCode) {
        return false;
      }

      return skipList.some(code => code === branchCode);
    }
    catch {
      return false;
    }
  }

}
